<template>
    <v-container fluid>
        <v-row v-if="!seafarer.gdpr_edit_lock">
            <v-col class="text-right">
                <v-btn class="ml-2 mr-2" color="primary" @click="documentDialog = true">
                    <v-icon small>fa-plus</v-icon>&nbsp;{{ $t('buttons.addDocument') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row
            style="
                margin-top: 3px;
                margin-bottom: 0px;
                scroll-margin: 0px;
                height: 82vh;
                overflow-y: scroll;
                overflow-x: hidden;
            "
        >
            <v-col cols="12">
                <div v-for="value in typesList" :key="value.value">
                    <SeafarerDocumentsTable :reload="reload" :seafarer="seafarer" :category="value" @edit="editItem" />
                </div> </v-col
        ></v-row>

        <v-row><v-col></v-col></v-row>
        <v-dialog persistent v-model="documentDialog" width="600">
            <v-card>
                <v-card-title v-if="object.id != 0">
                    {{ $t('labels.editDocument') }}
                </v-card-title>
                <v-card-title v-else>
                    {{ $t('labels.addDocument') }}
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-row dense wrap>
                                <v-col cols="12">
                                    <Dropdown
                                        :ajax="true"
                                        :data="'document-categories'"
                                        :label="'* ' + $t('fields.type')"
                                        @input="reloadDocumentTypes"
                                        v-model="typeId"
                                    ></Dropdown>
                                </v-col>
                                <v-col cols="12">
                                    <Dropdown
                                        v-model="object.document_type_id"
                                        :ajax="false"
                                        :data="documentTypes"
                                        :errorBorder="!objectValidation.document_type_id"
                                        :label="'* ' + $t('fields.documentType')"
                                        :key="componentKey"
                                    ></Dropdown>
                                </v-col>
                                <v-col cols="12">
                                    <Dropdown2
                                        v-model="object.issuing_country_id"
                                        :ajax="true"
                                        :data="'countries'"
                                        :errorBorder="!objectValidation.issuing_country_id"
                                        :label="$t('fields.issuingCountry')"
                                    ></Dropdown2>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        v-model="object.issued_by"
                                        :errorBorder="!objectValidation.issued_by"
                                        :label="$t('fields.issuedBy')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        v-model="object.document_number"
                                        :errorBorder="!objectValidation.document_number"
                                        :label="$t('fields.documentNumber')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <DatePicker
                                        v-model="object.date_issued"
                                        :errorBorder="!objectValidation.date_issued"
                                        :date-label="$t('fields.dateIssued')"
                                    ></DatePicker>
                                </v-col>
                                <v-col cols="12" class="pt-4 pb-0 mb-0">
                                    {{ $t('labels.validity') }}
                                </v-col>
                                <v-col cols="12" v-if="expirationTypesLoaded" class="pt-0 mt-0">
                                    <v-radio-group v-model="object.document_expiration_type_id" row class="pt-2 mt-0">
                                        <v-radio
                                            v-for="(item, key) in documentExpirationTypes"
                                            :key="key"
                                            :label="item.name"
                                            :value="item.id"
                                            color="primary"
                                            style="margin: auto"
                                        >
                                        </v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="12" v-if="object.document_expiration_type_id">
                                    <DatePicker
                                        :disabled="isDateOfExpiryDisabled"
                                        :readonly="isDateOfExpiryDisabled"
                                        v-model="object.date_of_expiry"
                                        :errorBorder="!objectValidation.date_of_expiry"
                                        :date-label="$t('fields.dateOfExpiry')"
                                    ></DatePicker>
                                </v-col>
                                <v-col cols="12">
                                    <Upload
                                        v-model="object.uploaded_file"
                                        :errorBorder="!objectValidation.uploaded_file"
                                    ></Upload>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col
                                    cols="12"
                                    md="6"
                                    class="text-right"
                                    :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                >
                                    <v-btn
                                        color="primary"
                                        class="white--text"
                                        :disabled="!expirationTypesLoaded"
                                        @click.stop="saveChanges"
                                        >{{ $t('buttons.save') }}
                                    </v-btn>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="6"
                                    class="text-left"
                                    :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                >
                                    <v-btn color="secondary" class="white--text" @click.stop="closeDialog"
                                        >{{ $t('buttons.cancel') }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import SeafarerDocumentsTable from './SeafarerDocumentsTable';
import SeafarerDocument from '../models/SeafarerDocument';
import Dropdown from '../components/trinkets/Dropdown';
import Dropdown2 from '../components/trinkets/Dropdown2';
import Upload from '@/components/trinkets/Upload';
import DatePicker from '@/components/trinkets/DatePicker';
import InputField from './trinkets/InputField';

export default {
    name: 'SeafarerDocuments',
    components: {DatePicker, SeafarerDocumentsTable, Dropdown, Dropdown2, Upload, InputField},
    props: ['seafarer', 'reload'],
    data: function () {
        return {
            initialLoad: false,
            languagesItems: [],
            lockKey: 'seafarer-documents',
            lockTimer: null,
            typesList: [],
            documentDialog: false,
            object: new SeafarerDocument({}),
            objectValidation: new SeafarerDocument({}, true),
            documentTypes: [],
            documentExpirationTypes: [],
            expirationTypesLoaded: false,
            typeId: null,
            componentKey: 0,
        };
    },
    watch: {
        'object.date_issued': {
            handler: function () {
                if (this.object.date_issued != null && this.object.date_of_expiry != null) {
                    const dateIssued = new Date(this.object.date_issued);
                    const dateOfExpiry = new Date(this.object.date_of_expiry);
                    if (dateIssued > dateOfExpiry) {
                        this.objectValidation.date_issued = false;
                        this.objectValidation.date_of_expiry = false;
                    } else {
                        this.objectValidation.date_issued = true;
                        this.objectValidation.date_of_expiry = true;
                    }
                }
                if (this.object.document_expiration_type_id) {
                    if (this.object.document_expiration_type_id == 1 || this.object.document_expiration_type_id == 2) {
                        this.object.date_of_expiry = this.addYearsToDate(this.object.document_expiration_type_id);
                    } else if (this.object.document_expiration_type_id == 3) {
                        this.object.date_of_expiry = this.addYearsToDate(5);
                    } else {
                        this.object.date_of_expiry = null;
                    }
                }
            },
            deep: true,
        },
        'object.date_of_expiry': {
            handler: function () {
                if (this.object.date_issued != null && this.object.date_of_expiry != null) {
                    const dateIssued = new Date(this.object.date_issued);
                    const dateOfExpiry = new Date(this.object.date_of_expiry);
                    if (dateIssued > dateOfExpiry) {
                        this.objectValidation.date_issued = false;
                        this.objectValidation.date_of_expiry = false;
                    } else {
                        this.objectValidation.date_issued = true;
                        this.objectValidation.date_of_expiry = true;
                    }
                }
            },
            deep: true,
        },
        'documentDialog'(newVal) {
            if (newVal) {
                this.loadExpiraitonTypes();
            }
        },
        'object.document_expiration_type_id'(newVal) {
            if (newVal == 1 || newVal == 2) {
                this.object.date_of_expiry = this.addYearsToDate(newVal);
            } else if (newVal == 3) {
                this.object.date_of_expiry = this.addYearsToDate(5);
            } else {
                this.object.date_of_expiry = null;
            }
        },
    },
    computed: {
        isDateOfExpiryDisabled() {
            return this.object.document_expiration_type_id == null || this.object.document_expiration_type_id != 5;
        },
    },

    methods: {
        addYearsToDate(years) {
            const currentDate = new Date(this.object.date_issued);
            currentDate.setFullYear(currentDate.getFullYear() + years);

            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        },
        reloadDocumentTypes() {
            let vm = this;
            this.$APICall('get', 'document-types-for-select/' + this.typeId, {}, (data, succes) => {
                if (succes) {
                    vm.documentTypes = data;
                    vm.componentKey += 1;
                }
            });
        },
        loadExpiraitonTypes() {
            let vm = this;
            this.$APICall('get', 'document-expiration-types', {}, (data, succes) => {
                if (succes) {
                    vm.documentExpirationTypes = data.items;
                    vm.expirationTypesLoaded = true;
                }
            });
        },
        editItem(item) {
            let vm = this;
            this.$APICall('get', 'seafarer-document/' + item, {}, (data, succes) => {
                if (succes) {
                    let usableData = JSON.parse(JSON.stringify(data));
                    vm.typeId = usableData.document_type.document_category.id;
                    vm.reloadDocumentTypes();
                    vm.object = usableData;
                    vm.documentDialog = true;
                }
            });
        },

        saveChanges() {
            let succes = true;
            if (this.object.document_type_id == null || this.object.document_type_id == '') {
                succes = false;
                this.objectValidation.document_type_id = false;
            } else {
                this.objectValidation.document_type_id = true;
            }
            if (
                this.object.uploaded_file == null ||
                this.object.uploaded_file.name == null ||
                this.object.uploaded_file.name == ''
            ) {
                succes = false;
                this.$alert(this.$t('alerts.uploadFile'));
            }

            if (succes) {
                this.object.seafarer_id = this.seafarer.id;
                let vm = this;
                let action = 'post';
                let addition = '';
                if (vm.object.id != 0) {
                    action = 'put';
                    addition = '/' + vm.object.id;
                }
                this.$APICall(action, 'seafarer-documents' + addition, this.object, (data, succes) => {
                    if (succes) {
                        vm.$notify(vm.$t('alerts.basicUpdate'));
                        this.closeDialog();
                        this.$modalBus.$emit('reloadDocumentsTable');
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                });
            }
        },

        closeDialog() {
            this.documentDialog = false;
            this.typeId = null;
            this.object = new SeafarerDocument({});
            this.objectValidation = new SeafarerDocument({}, true);
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        } else {
            let vm = this;
            this.$APICall('get', 'select/document-categories', {}, (data, succes) => {
                if (succes) {
                    vm.typesList = data;
                } else {
                    vm.$notify(vm.$t('alerts.basicError'));
                }
            });
            this.initialLoad = true;
        }
    },
};
</script>

<style scoped></style>
